const defaultState = {
    balanceLoading: false,
    balance: {
        amount: 0,
        currency: "eur",
    },
    withdrawDisabledReason: null,
    account: {},
    accountLoading: false,
    oauthLinkLoading: false,
    isUserOAuthorized: false,
    isUserOAuthorizedLoading: false,
    oauthLink: "",
    payoutsLoading: false,
    payouts: {
        object: "list",
        data: [],
        has_more: false,
        url: "/v1/payouts",
    },
    bankAccountLoading: false,
    bankAccount: {
        id: "",
        object: "",
        account: "",
        account_holder_name: null,
        account_holder_type: null,
        account_type: null,
        available_payout_methods: [],
        bank_name: "S",
        country: "",
        currency: "",
        default_for_currency: true,
        fingerprint: "",
        future_requirements: {
            currently_due: [],
            errors: [],
            past_due: [],
            pending_verification: [],
        },
        last4: "",
        metadata: {},
        requirements: {
            currently_due: [],
            errors: [],
            past_due: [],
            pending_verification: [],
        },
        routing_number: "",
        status: "",
    },
};

const accountReducer = (state = defaultState, action) => {
    switch (action.type) {
        case "GET_BALANCE_REQUEST":
            state = {
                ...state,
                balanceLoading: true,
            };
            break;
        case "GET_BALANCE_SUCCESS":
            state = {
                ...state,
                balanceLoading: false,
                balance: action.payload.balance,
                withdrawDisabledReason: action.payload.withdraw_disabled_reason || null,
            };
            break;
        case "GET_BALANCE_FAILURE":
            state = {
                ...state,
                balance: defaultState.balance,
                balanceLoading: defaultState.balanceLoading,
                withdrawDisabledReason: defaultState.withdrawDisabledReason,
            };
            break;
        case "GET_PAYOUTS_REQUEST":
            state = {
                ...state,
                payoutsLoading: true,
            };
            break;
        case "GET_PAYOUTS_SUCCESS":
            state = {
                ...state,
                payoutsLoading: false,
                payouts: action.payload.payouts,
            };
            break;
        case "GET_PAYOUTS_FAILURE":
            state = {
                ...state,
                payoutsLoading: defaultState.payoutsLoading,
                payouts: defaultState.payouts,
            };
            break;
        case "GET_ACCOUNT_REQUEST":
            state = {
                ...state,
                accountLoading: true,
            };
            break;
        case "GET_ACCOUNT_SUCCESS":
            state = {
                ...state,
                accountLoading: false,
                account: action.payload.account,
            };
            break;
        case "GET_ACCOUNT_FAILURE":
            state = {
                ...state,
                accountLoading: defaultState.accountLoading,
                account: defaultState.account,
            };
            break;
        case "GET_OAUTH_LINK_REQUEST":
            state = {
                ...state,
                oauthLinkLoading: true,
                oauthLink: defaultState.oauthLink,
            };
            break;
        case "GET_OAUTH_LINK_SUCCESS":
            state = {
                ...state,
                oauthLinkLoading: defaultState.oauthLinkLoading,
                oauthLink: action.payload.url,
            };
            break;
        case "GET_OAUTH_LINK_FAILURE":
            state = {
                ...state,
                oauthLinkLoading: defaultState.oauthLinkLoading,
                oauthLink: defaultState.oauthLink,
            };
            break;
        case "GET_BANK_ACCOUNT_REQUEST":
            state = {
                ...state,
                bankAccountLoading: true,
            };
            break;
        case "GET_BANK_ACCOUNT_SUCCESS":
            state = {
                ...state,
                bankAccountLoading: false,
                bankAccount: action.payload.bankAccount,
            };
            break;
        case "GET_BANK_ACCOUNT_FAILURE":
            state = {
                ...state,
                bankAccountLoading: defaultState.bankAccountLoading,
                bankAccount: defaultState.bankAccount,
            };
            break;
        case "GET_OAUTH_STATUS_REQUEST":
            state = {
                ...state,
                isUserOAuthorizedLoading: true,
            };
            break;
        case "GET_OAUTH_STATUS_SUCCESS":
            state = {
                ...state,
                isUserOAuthorizedLoading: false,
                isUserOAuthorized: action.payload,
            };
            break;
        case "GET_OAUTH_STATUS_FAILURE":
            state = {
                ...state,
                isUserOAuthorizedLoading: defaultState.isUserOAuthorizedLoading,
                isUserOAuthorized: defaultState.isUserOAuthorized,
            };
            break;
    }
    return state;
};

export default accountReducer;
